import { useQuery } from "@tanstack/react-query";
import { getProjectToday } from "./dailyLogSearchState";
import { projectDetailQueryOptions } from "./useProjectDetailQuery";

/**
 * 프로젝트 현지 기준 오늘(YYYY-MM-DD).
 * timezone을 모르면 null을 반환한다. 사용자 PC timezone으로 조용히 대체하지 않는다.
 */
export function useProjectToday(projectId: number) {
  const { data: project, refetch } = useQuery(projectDetailQueryOptions(String(projectId)));
  const today = project?.timezone ? getProjectToday(project.timezone) : null;

  return { today, retry: refetch };
}
